import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const routes = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/Views/GeneratingView')
    },
    {
      path: '/:id',
      component: () => import('@/Views/GeneratingView')
    }
  ]
})

export default routes;